<template>
	<img
		v-if="resolvedSrc"
		v-bind="$attrs"
		:src="resolvedSrc"
		@load="onLoad"
		@error="onError"
	/>
</template>

<script>
export default {
	name: 'assetImage',
	inheritAttrs: false,
	props: {
		src: {
			type: String,
			default: ''
		},
		strict: {
			type: Boolean,
			default: false
		},
		keepPrevious: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			resolvedSrc: '',
			requestId: 0
		}
	},
	watch: {
		src: {
			immediate: true,
			handler() {
				this.resolveSource();
			}
		}
	},
	beforeDestroy() {
		this.requestId += 1;
	},
	methods: {
		async resolveSource() {
			const requestId = ++this.requestId;
			if (!this.src) {
				this.resolvedSrc = '';
				return;
			}
			const previousResolvedSrc = this.resolvedSrc;
			// 头像可选择保留旧图，避免新资源解析期间闪回 fallback。
			if (!this.keepPrevious) {
				this.resolvedSrc = '';
			}
			if (this.strict && !this.$assetResolver.hasAssetSource(this.src)) {
				this.resolvedSrc = '';
				const error = new Error('资源暂不可用');
				this.$emit('resolve-error', error);
				return;
			}
			try {
				const resolved = await this.$assetResolver.resolve(this.src);
				if (requestId !== this.requestId) {
					return;
				}
				this.resolvedSrc = resolved.url || (this.keepPrevious ? previousResolvedSrc : '');
				this.$emit('resolved', resolved);
			} catch (error) {
				if (requestId !== this.requestId) {
					return;
				}
				if (!this.keepPrevious) {
					this.resolvedSrc = '';
				}
				this.$emit('resolve-error', error);
			}
		},
		onLoad(event) {
			this.$emit('load', event);
		},
		onError(event) {
			this.$emit('error', event);
		}
	}
}
</script>
